module.exports = __webpack_public_path__ + "img/shopping-games.5bcec650.svg";